export default __webpack_public_path__ + "static/media/unLocked.4040d957.svg";